import { Avatar, Flex, FlexProps, Text } from '@chakra-ui/react';
import { getMainPlatformData } from '~/core/utils';
import { formatPlatformHandle } from '~/creatorUtils';
import { ICreator } from '~/types';
import { convertPxToRems } from '~/utils-ts';

interface CreatorListItemProps extends FlexProps {
  creator: ICreator;
  onSelectCreator: (creator: ICreator) => void;
  trackId?: string;
}

export const CreatorListItem: React.FC<CreatorListItemProps> = ({
  creator,
  onSelectCreator,
  trackId,
}) => {
  const {
    avatar = '',
    name = 'Creator',
    handle = '',
    email,
  } = getMainPlatformData(creator);

  return (
    <Flex
      alignItems="center"
      paddingY={1}
      paddingLeft={2}
      cursor="pointer"
      _hover={{ backgroundColor: 'primary.50' }}
      borderRadius={convertPxToRems(5)}
      onClick={() => onSelectCreator(creator)}
      track-id={trackId}
    >
      <Avatar borderRadius="full" boxSize={10} src={avatar} />
      <Flex
        width="100%"
        noOfLines={2}
        flexDirection="column"
        alignItems="flex-start"
        marginLeft={2}
      >
        <Text
          noOfLines={1}
          color="primary.600"
          fontSize="lg"
          lineHeight={convertPxToRems(16)}
          fontWeight={500}
        >
          {name}
        </Text>
        <Text
          noOfLines={1}
          color="primary.300"
          fontSize="md"
          lineHeight={convertPxToRems(14)}
          fontWeight={400}
        >
          {handle ? formatPlatformHandle(handle) : email}
        </Text>
      </Flex>
    </Flex>
  );
};
